import React from 'react';
import styles from './Health.module.css';
import backgroundImage from '../../Images/T5.png'; // Import from images folder
import Thealth2 from '../../Images/T6.png';
import icon12 from '../../Images/icon12.png';
import icon15 from '../../Images/icon15.png';
import icon16 from '../../Images/icon16.png';

import iconT44 from '../../Images/icon45.png'; 
import iconT45 from '../../Images/icon46.png'; 
import iconT46 from '../../Images/icon47.png'; 
import iconT47 from '../../Images/icon48.png'; 
import iconT48 from '../../Images/icon50.png'; 

import T56 from '../../Images/T60.png'; 
import T57 from '../../Images/T57.png';
import T58 from '../../Images/T61.png';
import T59 from '../../Images/T59.png';

import T66 from '../../Images/T66.png';
import T67 from '../../Images/T67.png';

import iconT49 from '../../Images/icon77.png'; 

import icon1 from '../../Images/icon1.png';
import icon2 from '../../Images/icon2.png';
import icon3 from '../../Images/icon3.png';
import icon4 from '../../Images/icon4.png';
import bT1 from '../../Images/bT1.png';
import bT2 from '../../Images/bT2.png';
import bT3 from '../../Images/bT3.png';

// import bg1 from '../../Images/bg1.png';
// import cd1 from '../../Images/cd1.png';
// import cd2 from '../../Images/cd2.png';
// import cd3 from '../../Images/cd3.png';
// import cd4 from '../../Images/cd4.png';
// import sicon1 from '../../Images/sicon1.png';


const Health = () => {
  const handleCTAClick = (action) => {
    console.log(`${action} clicked`);
    // Add your navigation/modal logic here
  };

  return (
     <div className={styles.container61}>
  {/* Hero Section */}
  <section className={styles.heroSection61}>
    <div className={styles.heroContent61}>
      {/* Top label */}
      <div className={styles.heroLabel61}>
        <span className={styles.labelText61}>● AI-Powered Healthcare Solutions</span>
      </div>

      {/* Main headline */}
      <h1 className={styles.heroHeadline61}>
        Transform Healthcare & Patient Support with AI Intelligence
      </h1>

      {/* Subtext */}
      <p className={styles.heroSubtext61}>
        Empower your healthcare institution with ToxboxAI's cutting-<br />
        edge artificial intelligence solutions.Enhance security, streamline<br />
        operations, improve patient experiences, and make data-driven<br />
        decisions with confidence.
      </p>

      {/* CTA Buttons */}
      <div className={styles.ctaButtons61}>
        <button
          className={`${styles.ctaButton61} ${styles.ctaPrimary61}`}
          onClick={() => handleCTAClick('Request a Demo')}
        >
          Request a Demo →
        </button>
        <button
          className={`${styles.ctaButton61} ${styles.ctaSecondary61}`}
          onClick={() => handleCTAClick('Learn More')}
        >
          Watch Overview
        </button>
      </div>

      {/* Stats Section */}
      <div className={styles.statsSection61}>
        <div className={styles.statItem61}>
          <img src={icon12} alt="Speed Icon" className={styles.statIcon61} />
          <div className={styles.statValue61}>99.9%</div>
          <div className={styles.statLabel61}>Uptime Rate</div>
        </div>

        <div className={styles.statItem61}>
          <img src={icon15} alt="Satisfaction Icon" className={styles.statIcon61} />
          <div className={styles.statValue61}>$2.4B+</div>
          <div className={styles.statLabel61}>Data Secured</div>
        </div>

        <div className={styles.statItem61}>
          <img src={icon16} alt="Support Icon" className={styles.statIcon61} />
          <div className={styles.statValue61}>500+</div>
          <div className={styles.statLabel61}>Healthcare Providers</div>
        </div>
      </div>
    </div>

    {/* Background Image Container */}
    <div className={styles.heroBackground61}>
      <div
        className={styles.backgroundImage61}
        style={{
          backgroundImage: `url(${backgroundImage})`,
        }}
      />
    </div>
  </section>












   {/* What We Do */}
<section className={styles.health62}>
  <div className={styles.container62}>
    <div className={styles.header62}>
      <h2 className={styles.title62}>What We Do</h2>
    </div>
    
    <div className={styles.content62}>
      <div className={styles.textSection62}>
        <p className={styles.description62}>
          ToxBox AI helps healthcare organisations enhance <strong>patient engagement, streamline administrative tasks</strong>, and provide <strong>personalized care with AI-driven automation</strong>, while ensuring <strong>HIPAA compliance</strong>.
        </p>
        
        
      </div>
      
      <div className={styles.imageSection62}>
        <div className={styles.imageWrapper62}>
          <img 
            src={Thealth2} 
            alt="HIPAA Compliance Badge"
            className={styles.hipaaImage62}
          />
          
        </div>
      </div>
    </div>
  </div>
</section>    













{/* Healthcare AI Capabilities */}
<section className={styles.section63}>
  <div className={styles.container63}>
    {/* Header Section */}
    <div className={styles.headerSection63}>
      <h1 className={styles.title63}>
        Healthcare AI Capabilities 
        {/* <span className={styles.highlight44}>Retail</span> */}
      </h1>
      {/* <p className={styles.subtitle44}>
        Our AI-powered platform seamlessly integrates with your existing systems to deliver intelligent, automated support that scales with your needs.
      </p>  */}
    </div>
  
    {/* Capabilities Grid */}
    <div className={styles.capabilitiesGrid63}>
      {/* Card 1 */}
      <div className={styles.capabilityCard63}>
        <div className={styles.cardHeader63}>
          <div className={styles.cardIcon63}>
            <img 
              src={iconT44}
              alt="Customer Service Icon" 
              className={styles.iconImage63}
            />
          </div>
          <h3 className={styles.cardTitle63}>Patient Support Automation</h3>
        </div>
        <p className={styles.cardDescription63}>
          24/7 AI-driven patient queries.
        </p>
      </div>

      {/* Card 2 */}
      <div className={styles.capabilityCard63}>
        <div className={styles.cardHeader63}>
          <div className={styles.cardIcon63}>
            <img 
              src={iconT45} 
              alt="Customer Service Icon" 
              className={styles.iconImage63}
            />
          </div>
          <h3 className={styles.cardTitle63}>Appointment Scheduling</h3>
        </div>
        <p className={styles.cardDescription63}>
          Efficient booking and reminders.
        </p>
      </div>

      {/* Card 3 */}
      <div className={styles.capabilityCard63}>
        <div className={styles.cardHeader63}>
          <div className={styles.cardIcon63}>
            <img 
              src={iconT46} 
              alt="Customer Service Icon" 
              className={styles.iconImage63}
            />
          </div>
          <h3 className={styles.cardTitle63}>HIPAA Compliance</h3>
        </div>
        <p className={styles.cardDescription63}>
          Secure handling of patient data.
        </p>
      </div>

      {/* Card 4 */}
      <div className={styles.capabilityCard63}>
        <div className={styles.cardHeader63}>
          <div className={styles.cardIcon63}>
            <img 
              src={iconT47} 
              alt="Customer Service Icon" 
              className={styles.iconImage63}
            />
          </div>
          <h3 className={styles.cardTitle63}>Medical Query Assistance</h3>
        </div>
        <p className={styles.cardDescription63}>
          AI-driven guidance for common questions.
        </p>
      </div>

      {/* Card 5 */}
      <div className={styles.capabilityCard63}>
        <div className={styles.cardHeader63}>
          <div className={styles.cardIcon63}>
            <img 
              src={iconT48} 
              alt="Customer Service Icon" 
              className={styles.iconImage63}
            />
          </div>
          <h3 className={styles.cardTitle63}>Workflow Optimization</h3>
        </div>
        <p className={styles.cardDescription63}>
         Reduce administrative workload.
        </p>
      </div>

      
    </div>
  </div>
</section>















{/* AI Solutions for Healthcare Providers */}
<section className={styles.HealthProvider64}>
  <div className={styles.container64}>
    <h2 className={styles.title64}>AI Solutions for Healthcare Providers</h2>
    <p className={styles.subtitle64}>Empowering healthcare organizations with intelligent automation and AI-driven solutions</p>
    
    <div className={styles.cardsGrid64}>
      {/* Hospital & Clinics Card */}
      <div className={styles.card64}>
        <div className={styles.cardImageContainer64}>
          <img 
            src={T56} 
            alt="Hospital and Clinic AI Solutions"
            className={styles.cardImage64}
          />
        </div>
        <div className={styles.cardContent64}>
          <h3 className={styles.cardTitle64}>Hospitals & Clinics</h3>
          <p className={styles.cardDescription64}>
            Streamlined patient care and scheduling with AI-powered workflow automation.
          </p>
          {/* <ul className={styles.cardFeatures64}>
            <li className={styles.featureItem64}>Intelligent patient scheduling</li>
            <li className={styles.featureItem64}>Automated care coordination</li>
            <li className={styles.featureItem64}>Resource optimization</li>
          </ul> */}
        </div>
      </div>
      
      {/* Telemedicine Platforms Card */}
      <div className={styles.card64}>
        <div className={styles.cardImageContainer64}>
          <img 
            src={T57} 
            alt="Telemedicine AI Solutions"
            className={styles.cardImage64}
          />
        </div>
        <div className={styles.cardContent64}>
          <h3 className={styles.cardTitle64}>Telemedicine Platforms</h3>
          <p className={styles.cardDescription64}>
            Real-time AI support for virtual consultations and remote patient monitoring.
          </p>
          {/* <ul className={styles.cardFeatures64}>
            <li className={styles.featureItem64}>Virtual consultation assistance</li>
            <li className={styles.featureItem64}>Real-time symptom analysis</li>
            <li className={styles.featureItem64}>Remote monitoring tools</li>
          </ul> */}
        </div>
      </div>
      
      {/* Pharmacies Card */}
      <div className={styles.card64}>
        <div className={styles.cardImageContainer64}>
          <img 
            src={T58} 
            alt="Pharmacy AI Solutions"
            className={styles.cardImage64}
          />
        </div>
        <div className={styles.cardContent64}>
          <h3 className={styles.cardTitle64}>Pharmacies</h3>
          <p className={styles.cardDescription64}>
            Automated customer guidance and intelligent refill reminders for better medication adherence.
          </p>
          {/* <ul className={styles.cardFeatures64}>
            <li className={styles.featureItem64}>Automated refill reminders</li>
            <li className={styles.featureItem64}>Medication interaction alerts</li>
            <li className={styles.featureItem64}>Customer guidance systems</li>
          </ul> */}
        </div>
      </div>
      
      {/* Medical Labs Card */}
      <div className={styles.card64}>
        <div className={styles.cardImageContainer64}>
          <img 
            src={T59} 
            alt="Medical Lab AI Solutions"
            className={styles.cardImage64}
          />
        </div>
        <div className={styles.cardContent64}>
          <h3 className={styles.cardTitle64}>Medical Labs</h3>
          <p className={styles.cardDescription64}>
            AI-powered appointment scheduling and automated test result notifications.
          </p>
          {/* <ul className={styles.cardFeatures64}>
            <li className={styles.featureItem64}>Smart appointment scheduling</li>
            <li className={styles.featureItem64}>Automated result delivery</li>
            <li className={styles.featureItem64}>Test prioritization</li>
          </ul> */}
        </div>
      </div>
    </div>
  </div>
</section>









{/* Why Choose ToxBox AI for Healthcare? */}
<section className={styles.HealthCare65}>
  <div className={styles.container65}>
    <h2 className={styles.title65}>Why Choose ToxBox AI for Healthcare?</h2>
    
    <div className={styles.content65}>
      {/* Left Content with Image */}
      <div className={styles.leftSection65}>
        <div className={styles.leftImageContainer65}>
          <img 
            src={T66}
            alt="AI Solutions for Healthcare Providers"
            className={styles.sideImage65}
          />
        </div>
        
        
      
        
        <div className={styles.rightImageContainer65}>
          <img 
            src={T67} 
            alt="Healthcare AI Benefits"
            className={styles.sideImage65}
          />
        </div>
      </div>
    </div>
  </div>
</section>











{/* Ready to Transform Your Telecom Support? */}
<section className={styles.ctaSection74}>
  <div className={styles.sectionContent74}>
    <h2 className={styles.ctaHeadline74}>
      Enhance Your Healthcare Services with AI Today
    </h2>

    <p className={styles.ctaSubtext74}>
      Join hundreds of healthcare providers transforming patient care with intelligent automation.
    </p>

    <div className={styles.ctaButtons74}>
      <button 
        className={`${styles.ctaButton74} ${styles.ctaPrimary74}`}
        onClick={() => handleCTAClick('Request a Demo')}
      >
        Get Started →
      </button>
 
      <button 
        className={`${styles.ctaButton74} ${styles.ctaSecondary74}`}
        onClick={() => handleCTAClick('Get Started Now')}
      >
        Learn More
      </button>
    </div>
  </div>
</section>



      
    </div>
  );
};

export default Health;
